export default __webpack_public_path__ + "static/blog-img2-e55248b55cae0fc07d3b1f2703ec6ac0.png";